import { PaginationRequestType } from "@/entity/common/pagination.types";
import Api from "@/repository/api";
import qs from "qs";

export function getResponse(ApiUrl: string, data?: FormData): any {
  return Api.get(ApiUrl, {
    params: data,
    paramsSerializer: function paramsSerializer(params) {
      return new URLSearchParams(params).toString();
    },
  });
}
export function getResponseQs(
  ApiUrl: string,
  data: PaginationRequestType
): any {
  return Api.get(ApiUrl, {
    params: data,/**/
    paramsSerializer: function paramsSerializer(params) {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
}
